import React from "react";
import PropTypes from "prop-types";
import { Typography } from "antd";
import { DashboardOutlined } from "@ant-design/icons";
const { Title } = Typography;
const Header = ({ darkMode, toggleDarkMode, styles }) => {
  return (
    <div style={styles.header}>
      <Title level={2} style={styles.headerTitle}>
        <DashboardOutlined /> Manager Dashboard
      </Title>
      <div style={styles.headerActions}>
      </div>
    </div>
  );
};
Header.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  toggleDarkMode: PropTypes.func.isRequired,
  styles: PropTypes.shape({
    header: PropTypes.object,
    headerTitle: PropTypes.object,
    headerActions: PropTypes.object,
  }).isRequired,
};

export default Header;
